import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { MojoFeatureExtensionsModule, MojoFeatureExtensionsService, } from 'mojo-feature-extensions';

import { LicenseConfigurationService } from './license-configuration.service';
import { LicenseConfigurationEffects, licenseConfigurationReducer, } from './store';

@NgModule({
  imports: [
    StoreModule.forFeature(
      'license-configuration',
      licenseConfigurationReducer,
    ),
    EffectsModule.forFeature([LicenseConfigurationEffects]),
    MojoFeatureExtensionsModule.forRoot(MojoFeatureExtensionsService),
  ],
  providers: [LicenseConfigurationService, MojoFeatureExtensionsService],
})
export class LicenseConfigurationModule {}
